import React from 'react';
import { GENERIC_ERROR_MESSAGE } from '../utils/constants';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null, showDetails: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);

    // The splash overlay is removed by an effect inside AppContent (App.jsx).
    // A crash during render means that effect never runs, leaving an opaque
    // z-index:9999 overlay on top of this page. Take it down ourselves.
    const splash = document.getElementById('splash');
    if (splash) splash.remove();

    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      const isDev = import.meta.env.DEV;

      return (
        <div className="min-h-screen bg-white px-6">
          <div className="mx-auto max-w-[600px] pt-[14vh]">
            <svg
              className="mb-8"
              width="72"
              height="72"
              viewBox="0 0 72 72"
              fill="none"
              aria-hidden="true"
            >
              <rect x="18" y="20" width="8" height="16" rx="4" fill="#9aa0a6" />
              <rect x="46" y="20" width="8" height="16" rx="4" fill="#9aa0a6" />
              <path
                d="M20 54 Q36 40 52 54"
                stroke="#9aa0a6"
                strokeWidth="6"
                strokeLinecap="round"
                fill="none"
              />
            </svg>

            <h1 className="mb-4 text-[24px] font-normal leading-[1.25] text-[#202124]">
              This page didn&apos;t load
            </h1>

            <p className="mb-4 text-[15px] leading-[1.55] text-[#5f6368]">
              {GENERIC_ERROR_MESSAGE}
            </p>

            <p className="text-[12px] uppercase tracking-wide text-[#5f6368]">
              ERR_APP_CRASHED
            </p>

            <div className="mt-8 flex items-center justify-between">
              {isDev ? (
                <button
                  onClick={() => this.setState({ showDetails: !this.state.showDetails })}
                  className="text-[14px] font-medium text-[#1a73e8] hover:text-[#174ea6]"
                >
                  {this.state.showDetails ? 'Hide details' : 'Details'}
                </button>
              ) : (
                <div />
              )}

              <button
                onClick={() => window.location.reload()}
                className="rounded bg-[#1a73e8] px-4 py-2 text-[14px] font-medium text-white transition hover:bg-[#1b66c9]"
              >
                Reload
              </button>
            </div>

            {isDev && this.state.showDetails && (
              <pre className="mt-6 overflow-auto rounded bg-[#f1f3f4] p-3 text-[12px] leading-[1.5] text-[#5f6368]">
                {this.state.error && this.state.error.toString()}
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
